'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"
import router from "@/router";

export default {
    // Leave Types
    async getLeaveTypes() {
        const data = {
            method: 'get',
            url: 'leave-types',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async createLeaveType(json) {
        const data = {
            method: 'post',
            url: 'leave-type',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 201) {
            notify.alert.success('Leave type created successfully')
            return response.data
        }
    },
    async getLeaveType(id) {
        const data = {
            method: 'get',
            url: 'leave-type/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async updateLeaveType(id, json) {
        const data = {
            method: 'patch',
            url: 'leave-type/' + id,
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Leave type updated successfully')
            return response.data
        }
    },
    async deleteLeaveType(id) {
        const data = {
            method: 'delete',
            url: 'leave-type/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Leave type deleted successfully')
            return true
        }
    },

    // Leave Requests
    async getLeaveRequests() {
        const data = {
            method: 'get',
            url: 'leave-requests'
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async filterLeaveRequests(json) {
        const data = {
            method: 'post',
            url: 'leave-requests/filter',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async createLeaveRequest(json) {
        const data = {
            method: 'post',
            url: 'leave-request',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 201) {
            notify.alert.success('Leave request created successfully')
            return response.data
        }
    },
    async getLeaveRequest(id) {
        const data = {
            method: 'get',
            url: 'leave-request/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async approveLeaveRequest(id, comments = '') {
        const data = {
            method: 'patch',
            url: 'leave-request/approve/' + id,
            body: { comments: comments },
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Leave request approved successfully')
            return response.data
        }
    },
    async rejectLeaveRequest(id, json) {
        const data = {
            method: 'patch',
            url: 'leave-request/reject/' + id,
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Leave request rejected successfully')
            return response.data
        }
    },
    async getLeaveApprovers() {
        const data = {
            method: 'get',
            url: 'leave-approvers',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async createLeaveApprover(json) {
        const data = {
            method: 'post',
            url: 'leave-approver',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 201) {
            notify.alert.success('Leave approver created successfully')
            return response.data
        }
    },
    async deleteLeaveApprover(id) {
        const data = {
            method: 'delete',
            url: 'leave-approver/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Leave approver deleted successfully')
            return true
        }
    },

    // Reassign leave approval to another user
    async reassignLeaveApproval(approvalId, userId) {
        const data = {
            method: 'post',
            url: 'leave-approvals/' + approvalId + '/reassign',
            body: { user_id: userId },
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Approval reassigned successfully')
            return response
        }
    },

    // Leave Balances
    async getLeaveBalances() {
        const data = {
            method: 'get',
            url: 'leave-balances'
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async filterLeaveBalances(json) {
        const data = {
            method: 'post',
            url: 'leave-balances/filter',
            body: json
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    async createLeaveBalance(json) {
        const data = {
            method: 'post',
            url: 'leave-balance',
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 201) {
            notify.alert.success('Leave balance created successfully')
            return response.data
        }
    },
    async updateLeaveBalance(id, json) {
        const data = {
            method: 'patch',
            url: 'leave-balance/' + id,
            body: json,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            notify.alert.success('Leave balance updated successfully')
            return response.data
        }
    },
    // Leave Analytics
    async getLeaveAnalytics(year = null) {
        const data = {
            method: 'get',
            url: 'leave-analytics',
            params: year ? { year } : {}
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },
    // Employee Leaves
    async getEmployeeLeaves(id) {
        const data = {
            method: 'get',
            url: 'employee/' + id + '/leaves',
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    },

    async getLeaveApprovals(id) {
        const data = {
            method: 'get',
            url: 'leave-approvals/' + id,
        }

        const response = await api.api(data)
        if (response.status === 200) {
            return response.data
        }
    }
}
